import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ResourceManager from "@/pages/admin/ResourceManager";
import Leads from "@/pages/admin/Leads";
import Settings from "@/pages/admin/Settings";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function PublicSite() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <LenisBridge />
      <Home />
    </ReactLenis>
  );
}

function RequireAuth({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-glg-black text-white/60">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="services" element={<ResourceManager resource="services" />} />
              <Route path="brands" element={<ResourceManager resource="brands" />} />
              <Route path="software" element={<ResourceManager resource="software" />} />
              <Route path="testimonials" element={<ResourceManager resource="testimonials" />} />
              <Route path="promotions" element={<ResourceManager resource="promotions" />} />
              <Route path="leads" element={<Leads />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
